import React, { useEffect } from 'react'
import {
    AUTH_SESSION_EXPIRED_EVENT,
    type AuthSessionExpiredEventDetail,
} from '@barbershop/api/auth-refresh'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

export function getContext() {
    return {
        queryClient,
    }
}

export const WithTanstackQuery: React.FC<React.PropsWithChildren> = ({ children }) => {
    useEffect(() => {
        const handleAuthSessionExpired = (event: Event) => {
            const { loginPath } = (event as CustomEvent<AuthSessionExpiredEventDetail>).detail

            queryClient.clear()

            if (globalThis.location.pathname !== loginPath) {
                globalThis.location.assign(loginPath)
            }
        }

        globalThis.addEventListener(AUTH_SESSION_EXPIRED_EVENT, handleAuthSessionExpired)

        return () => {
            globalThis.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, handleAuthSessionExpired)
        }
    }, [])

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
